import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import TimePicker from 'react-time-picker'

import {GenericTable} from '../../Utils'

import {filterParkings, sumReservedAndCurrentParkings} from '../../../utils'

class CustomParkingTable extends Component {

    constructor(props){
        super(props)
        this.headers = [
            {name: "Placa", small: true},
            {name: "Evento", small: true},
            {name: "Reservacion", small: true},
            {name: "Entrada esperada", small: true, render: 'date-time'},
            {name: "Entrada actual", small: true, render: 'date-time'},
            {name: "Salida esperada", small: true, render: 'date-time'}
        ]

        this.getTableData = this.getTableData.bind(this)
    }

    getTableData(expectedParkings, currentOccupation, timeSelected){
        const endTime = timeSelected + 30*60*1000
        const filterReservedparkings = filterParkings(
            expectedParkings, timeSelected, endTime)
        sumReservedAndCurrentParkings(
            filterReservedparkings,
            currentOccupation,
            endTime
        )
        var result = []
        for (var rowDict in filterReservedparkings){
            const row = [
                filterReservedparkings[rowDict]['plate'],
                filterReservedparkings[rowDict]['eventId'],
                filterReservedparkings[rowDict]['resId'],
                filterReservedparkings[rowDict]['expected_start'],
                filterReservedparkings[rowDict]['start'],
                filterReservedparkings[rowDict]['end']
            ]
            result.push(row)
        }
        return result
    }

    render(){
        const {
            timeSelected,
            expectedParkings,
            currentOccupation,
            onTimeChange,
            disabled
        } = this.props
        const {headers, getTableData} = this
        // End time is time selected plus 30 min
        const tableData = getTableData(
            expectedParkings,
            currentOccupation,
            timeSelected
        )
        return (
            <div>
                <div className="line-header-text">Estado</div>
                <div className="parking-table-date-picker">
                    <div>
                        <DatePicker
                            selected={timeSelected}
                            disabled={disabled}
                            onChange={value => onTimeChange('startDate', value)}
                        />
                    </div>
                    <div>
                        <TimePicker
                            value={new Date(timeSelected)}
                            disabled={disabled}
                            clearIcon={null}
                            clockIcon={null}
                            onChange={value => onTimeChange('startTime', value)}
                            className="time-picker-style"
                            disableClock={true}
                        />
                    </div>
                </div>
                <div className="parking-table-occupancy-box">
                    <p>Espacios ocupados: {Object.keys(currentOccupation).length}</p>
                </div>
                <div className="parking-table-occupancy-box">
                    <p>Espacios reservados: {tableData.length - Object.keys(currentOccupation).length}</p>
                </div>
                <div>
                    <GenericTable
                        headers={headers}
                        tableData={tableData}
                        columnOrderIndex={2}
                    />
                </div>
            </div>
        )
    }
}

export default CustomParkingTable
